import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  // issue
  searchIssue(URL, header, success, error) {
    Vue.axios.get(URL + 'issue', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getIssue(URL, isu_id, header, success, error) {
    Vue.axios.get(URL + 'issue/' + isu_id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addIssue(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'issue', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editIssue(URL, isu_id, obj, header, success, error) {
    Vue.axios.put(URL + 'issue/' + isu_id, obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  // issue detail temp
  getIssueDetailTemp(URL, header, success, error) {
    Vue.axios.get(URL + 'issuedetailtemp', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addIssueDetailTemp(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'issuedetailtemp', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteIssueDetailTemp(URL, isudt_id, header, success, error) {
    Vue.axios.delete(URL + 'issuedetailtemp/' + isudt_id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/issue.js